import React, { useState, ChangeEvent } from 'react';
import cn from 'classnames';
import './TextField.scss';

export type Props = {
  /** Атрибут type */
  type?: string;

  /** Атрибут value */
  value?: string;

  /** Атрибут placeholder */
  placeholder?: string;

  /** Идентификатор поля */
  id?: string;

  /** Атрибут name */
  name?: string;

  /** Автозаполнение поля */
  autoComplete?: string;

  /** Атрибут maxlength */
  maxLength?: number;

  /** Неактивное состояние поля */
  disabled?: boolean;

  input?: React.InputHTMLAttributes<HTMLInputElement>;

  /** Обработчик события onFocus */
  onFocus?: (event: React.FocusEvent<HTMLInputElement>) => void;

  /** Обработчик события onChange */
  onChange?: (event: ChangeEvent) => void;

  /** Обработчик события onBlur */
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;

  /** Дополнительный класс */
  className?: string;
} & React.HTMLAttributes<HTMLDivElement>;

export type Ref = HTMLInputElement;

const TextField = React.forwardRef<Ref, Props>((props, inputRef) => {
  const {
    type = 'text',
    value,
    placeholder,
    name,
    autoComplete = 'off',
    maxLength,
    disabled = false,
    id,
    input,
    onFocus,
    onChange,
    onBlur,
    className,
    ...attr
  } = props;
  const [focused, setFocused] = useState(false);

  const handleFocus = (e: React.FocusEvent<HTMLInputElement>): void => {
    setFocused(true);

    if (onFocus) {
      onFocus(e);
    }
  };

  const handleBlur = (e: React.FocusEvent<HTMLInputElement>): void => {
    setFocused(false);

    if (onBlur) {
      onBlur(e);
    }
  };

  const handleChange = (e: ChangeEvent): void => {
    if (onChange) {
      onChange(e);
    }
  };

  const inputWrapperProps = {
    className: cn(
      'text-field',
      focused && 'text-field_focused',
      disabled && 'text-field_disabled',
      className
    ),
    ...attr,
  };

  const inputProps: React.InputHTMLAttributes<HTMLInputElement> = {
    ...input,
    className: 'text-field__input',
    type,
    id,
    value,
    placeholder,
    name,
    maxLength,
    disabled,
    autoComplete,
    onFocus: handleFocus,
    onChange: handleChange,
    onBlur: handleBlur,
  };

  return (
    <div {...inputWrapperProps}>
      <input ref={inputRef} {...inputProps} />
    </div>
  );
});

export default TextField;
